import { render } from "./SurveyResultContent.vue?vue&type=template&id=0a23568a&scoped=true"
import script from "./SurveyResultContent.vue?vue&type=script&lang=js"
export * from "./SurveyResultContent.vue?vue&type=script&lang=js"

import "./SurveyResultContent.vue?vue&type=style&index=0&id=0a23568a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a23568a"]])

export default __exports__